import { siteInfo } from '@/mocks/comics';

export default function StatsSection() {
  const stats = [
    { label: '正版漫画', value: siteInfo.totalComics, icon: 'ri-book-2-line' },
    { label: '注册用户', value: siteInfo.totalUsers, icon: 'ri-user-heart-line' },
    { label: '日活跃用户', value: siteInfo.dailyActive, icon: 'ri-fire-line' },
    { label: '成立年份', value: siteInfo.founded, icon: 'ri-calendar-check-line' },
  ];

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="bg-background-100 rounded-xl p-8 md:p-10">
          <div className="text-center mb-8">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-2">
              平台数据
            </h2>
            <p className="text-sm text-foreground-500">信赖之选，千万读者的共同选择</p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
                  <i className={`${stat.icon} text-lg`} style={{ color: `oklch(var(--primary-500))` }}></i>
                </div>
                <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                  {stat.value}
                </div>
                <div className="text-sm text-foreground-500 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}